import React, { useMemo, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom"; // Import useNavigate and Link


import { toast } from 'react-toastify';

import { useSelector, useDispatch } from 'react-redux'; // Import useSelector and useDispatch
import { fetchIntegrationById, saveIntegrationAsync } from '../../Redux/slices/integrationSlice'; // Import the async thunk


import Tabs from "../../Common/misc/Tabs";
import ConfirmDetails from "./Components/ConfirmDetails";

import tabsList from "@Common/data/editor-tabs.json";

const AddIntegrationSummary = () => {
  const dispatch = useDispatch();
  const integrationDetails = useSelector((state) => state.integration.selectedIntegration);
  const status = useSelector((state) => state.integration.status);
  const error = useSelector((state) => state.integration.error);

  const { id } = useParams();

  useEffect(() => {
    dispatch(fetchIntegrationById(id));
  }, [dispatch, id]);


  const navigate = useNavigate(); // Get the navigate function

  const handleGotoHome = () => { navigate("/"); }

  const handleGoToDashboard = () => {
    // router.back();
    navigate("/integrations/listing");

  };
  
  const onTabSelected = (pageName) => {
    navigate(`/integrations/${id}/${pageName.toLowerCase()}`);
  }

  const handleGotoListing = () => {
    //router.push("/add-integration/source-details"); // Navigates to the /about page
    navigate(`/integrations/listing`); // Navigate to the next page
  };

  //   const [activeLink, setActiveLink] = useState(null);
  //   const [scrollActive, setScrollActive] = useState(false);

  // useEffect(() => {
  //   window.addEventListener("scroll", () => {
  //     setScrollActive(window.scrollY > 20);
  //   });
  // }, []);

  return (
    <div className="mx-auto mt-14 max-w-screen-2xl px-8 xl:px-16">
      <section className="">
        <div className="sm:flex sm:items-center sm:justify-between">
          <div>
            <div className="flex items-center gap-x-3">
              <button
                onClick={handleGotoHome}
                className="bg-white flex w-1/2 items-center justify-center gap-x-2 rounded-lg bg-gray-200 px-2 py-2 text-sm text-gray-800 transition-colors duration-200 hover:bg-gray-400 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
              >
                Home
              </button>
              <button
                onClick={handleGoToDashboard}
                title="Dashboard"
                className="flex w-1/2 items-center justify-center gap-x-2 rounded-lg bg-gray-200 px-2 py-2 text-sm text-gray-700 transition-colors duration-200 hover:bg-gray-400 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
              >
                <svg className="h-5 w-6" viewBox="0 -4.5 31 31" version="1.1" fill="#000000">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round"
                    strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier">
                    <desc>Created with Sketch Beta.</desc> <defs> </defs>
                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g id="Icon-Set-Filled"
                        transform="translate(-206.000000, -626.000000)" fill="#000000">
                        <path d="M235,643 L216,643 C214.896,643 214,643.896 214,645 C214,646.104 214.896,647 216,647 L235,647 C236.104,647 237,646.104 237,645 C237,643.896 236.104,643 235,643 L235,643 Z M235,635 L216,635 C214.896,635 214,635.896 214,637 C214,638.104 214.896,639 216,639 L235,639 C236.104,639 237,638.104 237,637 C237,635.896 236.104,635 235,635 L235,635 Z M216,631 L235,631 C236.104,631 237,630.104 237,629 C237,627.896 236.104,627 235,627 L216,627 C214.896,627 214,627.896 214,629 C214,630.104 214.896,631 216,631 L216,631 Z M209,642 C207.343,642 206,643.343 206,645 C206,646.657 207.343,648 209,648 C210.657,648 212,646.657 212,645 C212,643.343 210.657,642 209,642 L209,642 Z M209,634 C207.343,634 206,635.343 206,637 C206,638.657 207.343,640 209,640 C210.657,640 212,638.657 212,637 C212,635.343 210.657,634 209,634 L209,634 Z M209,626 C207.343,626 206,627.343 206,629 C206,630.657 207.343,632 209,632 C210.657,632 212,630.657 212,629 C212,627.343 210.657,626 209,626 L209,626 Z" id="list" > </path> </g> </g> </g></svg>
              </button>

              <h2 className="dark:text-white w-80 text-lg font-medium text-gray-800">
                {status === 'loading' ? (
                  <div className="my-1 animate-pulse">
                    <div className="h-8 w-80 rounded-full bg-gray-200 dark:bg-gray-700">
                    </div>
                  </div>
                ) : (
                  integrationDetails && integrationDetails.name && integrationDetails.name
                )}
              </h2>

              <div className="rounded-full px-3 py-0 text-xs">
                <Tabs tabsList={tabsList} selectedIndex={5} interactive={true} onTabSelected={onTabSelected} />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-end gap-x-2"> {/* Add this div for buttons */}
            <button
              onClick={handleGotoListing}
              className="flex w-1/2 items-center justify-center gap-x-2 rounded-lg bg-blue-400 px-2 py-2 text-sm text-white-500 transition-colors duration-200 hover:bg-blue-500 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
            >
              Go to All Integrations
            </button>
          </div>
        </div>
        <div className="mt-4">
          <ConfirmDetails details={integrationDetails} />
        </div>
      </section>
    </div>
  )
}

export default AddIntegrationSummary;